import { render, staticRenderFns } from "./TermOfAcceptanceForm.vue?vue&type=template&id=384c65a5&scoped=true&"
import script from "./TermOfAcceptanceForm.vue?vue&type=script&lang=js&"
export * from "./TermOfAcceptanceForm.vue?vue&type=script&lang=js&"
import style0 from "./TermOfAcceptanceForm.vue?vue&type=style&index=0&id=384c65a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c65a5",
  null
  
)

export default component.exports